import type { ListNotificationsArgs } from '../types/notification.types';
import { NotificationType } from '../types/notification.types';
import { DealroomEventType } from '../../timeline/types/log.types';

export default class NotificationConstants {
  static defaultFilter: ListNotificationsArgs = {
    type: NotificationType.Dealroom,
    dealroomId: '',
    participantId: '',
    limit: 200,
    offset: 0,
    eventTypes: undefined,
  };

  static defaultFilterUnreadCommentNotifications: Partial<ListNotificationsArgs> = {
    eventTypes: [
      DealroomEventType.ContextualCommentReplyCreated,
      DealroomEventType.ContextualCommentUpdated,
    ],
  };

  static defaultFilterUnreadChatNotifications: Partial<ListNotificationsArgs> = {
    eventTypes: [DealroomEventType.ConversationMessageCreated],
  };

  static defaultFilterUnreadOtherNotifications: Partial<ListNotificationsArgs> = {
    eventTypes: [
      DealroomEventType.Visited,
      DealroomEventType.FileUploaded,
      DealroomEventType.ParticipantCreated,
      DealroomEventType.TaskCreated,
      DealroomEventType.TaskUpdated,
    ],
  };

  static navigatableTypes: Partial<DealroomEventType[]> = [
    DealroomEventType.TaskCreated,
    DealroomEventType.TaskUpdated,
    DealroomEventType.FileUploaded,
    DealroomEventType.ConversationMessageCreated,
    DealroomEventType.ContextualCommentReplyCreated,
    DealroomEventType.ContextualCommentUpdated,
  ];

  static typesWithMetaDataContent: Partial<DealroomEventType[]> = [
    DealroomEventType.ConversationMessageCreated,
    DealroomEventType.ContextualCommentReplyCreated,
    DealroomEventType.ContextualCommentUpdated,
  ];
}
